<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-12-15 14:37:15
 * @LastEditors: sjq
 * @LastEditTime: 2023-12-18 10:09:53
 -->
<template>
  <div class="container">
    <div class="second-page">
      <div class="top">
        <span>长按图片保存到相册，快去分享到朋友圈吧~</span>
        <img src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526142068_s1754.jpg" alt="" />
      </div>
      <div class="main">
        <img
          class="decorate-circle-1"
          src="https://img-cdn1.ylyk.com/image/1638774210959_m1638774027617_s6597.jpg"
          alt=""
        />
        <div class="pic-main">
          <!--          <img class="decorate-l" src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108297_s999.jpg" alt="">-->
          <div id="capture" class="pic-wrapper">
            <!-- https://hsyx-images.oss-cn-beijing.aliyuncs.com/2022/12/23/%E7%BB%88%E6%9E%81%E6%A8%A1%E6%9D%BF2_1671764809677.jpg" -->
            <img class="cover" @load="onImageLoad" crossorigin="anonymous" :src="bgUrl" alt="" v-if="showBg" />
            <div class="div-user" v-if="showBg || hasHead">
              <img class="avatar" :src="headUrl" v-if="showBg" alt="" />
              <div class="nickName" v-if="showBg">{{ nickName }}</div>
            </div>
            <!-- <div class="div-qrcode" v-if="showBg">
              <div>
                <div class="tv_">长按扫码</div>
                <div class="tv_" style="margin-top: 2px">领取你的2024</div>
                <div class="tv_" style="margin-top: 2px">新年关键词</div>
              </div>
              <img class="img-qrcode" src="../../../../assets/images/qrcode_xsyw.png" alt="" />
            </div> -->
            <img class="cover" crossorigin="anonymous" :src="canvasUrl" alt="" />
          </div>
          <img class="decorate-r" src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526142057_s900.jpg" alt="" />
        </div>
        <template v-if="videoUrl">
          <div class="banner-title specialTitle1">
            <img src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108293_s642.jpg" alt="" />
            <span>下滑获取你的新年专属【祝福视频】</span>
            <img src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108293_s669.jpg" alt="" />
          </div>
          <video class="video" controls="controls" :src="videoUrl" :poster="coverUrl" @playing="palyVideo"></video>
        </template>
        <div class="banner-title specialTitle1">
          <img src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108293_s642.jpg" alt="" />
          <span>↓领取你的新年礼↓</span>
          <img src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108293_s669.jpg" alt="" />
        </div>
        <img class="banner" @click="onBannerClick" :src="bannerUrl" />
        <!-- <img
          v-if="detail.floatUrl"
          class="floating"
          @click="onFloatClick"
          id="moveDiv"
          :style="position"
          @mousedown="down"
          @touchstart="down"
          @mousemove="moveFloat"
          @touchmove="moveFloat"
          @mouseup="end"
          @touchend="end"
          :src="detail.floatUrl"
          alt=""
        /> -->
      </div>
    </div>
    <div class="first-page" v-if="showFirstPage">
      <!-- <div class="wordCloud__tagBall" :style="{ width: `${this.width}px`, height: `${this.height}px` }">
        <span
          class="wordCloud__tag"
          v-for="(item, index) of data"
          :key="index"
          :style="{ color: color[index % color.length], ...contentEle[index].style }"
        >
          {{ item }}
        </span>
      </div> -->
      <div class="img_detail">
        <img
          :style="{ width: `${this.width}px` }"
          src="https://img-cdn1.ylyk.com/image/1702971110077_m1702970918228_s52424.jpg"
          alt=""
        />
      </div>
      <button class="btn_detail" @click="checkDetail">立 即 抽 取</button>
      <div class="note" @click="showNote">活动介绍</div>
    </div>
    <div class="mask" v-if="showMask">
      <div class="note-content">
        <div class="pre">
          <div class="title">活动介绍</div>
          <b>1. 如何参加活动？</b>
          <div class="commit">
            点击【立即抽取】按钮，即可抽取你的2024新年关键词。抽取关键词海报后，还可以长按保存到手机相册，转发海报给好友或分享到朋友圈，邀请你的朋友一起来试试手气~
          </div>

          <b>2. 新年有什么福利？</b>
          <div class="commit">
            新用户可免费参加【新年畅听体验营】，1月1日正式开课，5天时间畅听「友邻少年APP」680+英文好课，更有三场精彩的英语学习直播讲座，高手学英语的方法和心法，全都告诉你！新的一年想要学好英语，就从这里开始吧！
          </div>

          <b>3. 谁可以领取新年福利？</b>
          <div class="commit">
            友邻新学员，外刊年卡学员，只买过一门或者某几门课程的同学，都可以报名。只要你不是「畅听年卡会员」或者「无限卡会员」，都能参加。
          </div>
          <b>4. 报名后如何听课？</b>
          <div class="commit">
            报名成功后，即会弹出班主任微信二维码，扫码添加，后续如何听课以及观看直播讲座等问题都可以咨询班主任老师。一定要去添加哦~
          </div>
        </div>
        <img class="decorate" src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108338_s795.jpg" alt="" />
      </div>
      <img class="close" @click="closeNote" src="../../../../assets/images/btn_close.png" alt="" />
    </div>
    <div class="mask-gif" v-if="showGif">
      <img class="img-gif" src="https://img-cdn1.ylyk.com/image/1639450332873_m1639450247940_s1808108.jpg" alt="" />
    </div>
    <img
      class="floating"
      @click="onFloatClick"
      id="moveDiv"
      :style="position"
      @mousedown="down"
      @touchstart="down"
      @mousemove="moveFloat"
      @touchmove="moveFloat"
      @mouseup="end"
      @touchend="end"
      src="https://img-cdn1.ylyk.com/image/1703144962046_m1703144560446_s228451.jpg"
      alt=""
    />
  </div>
</template>

<script>
import { appUser, storage } from '@/utils'
import { AsyncRequest } from '@/utils/request'
import { pullnewService } from '@/api'
import Body from '@/mixins/body'
import html2canvas from './html2canvas'
import { toLoginView } from '@/utils/init/env-init'
import { saTrack } from '@/utils/common/shence'

// 进入页面首先显示词云动画，用户点击抽取关键词按钮之后，微信静默登录。登录成功之后获取用户的openid头像等信息，不需要进入我们自己的登录页面
// 登录成功之后通过openId请求详情数据，展示加载动画，详情数据返回之后，生成海报图片，取消加载动画展示内容
export default {
  name: 'pullnew', // 年度拉新
  data: () => ({
    data: [],
    color: ['#ffffff'],
    contentEle: [],
    width: 300,
    height: 300,
    direction: '-3',
    speed: 1000,
    showMask: false,

    bgUrl: '',
    headUrl: '',
    canvasUrl: '',
    coverUrl: '',
    videoUrl: '',
    bannerUrl: '',
    campUrl: '',
    nickName: '',
    showBg: true,
    hasHead: true,
    showFirstPage: true,
    showGif: false,
    detail: '',

    // 以下是浮窗拖动相关参数
    position: {
      type: Object,
      default: function () {
        return {
          top: '32.25rem',
          left: '18.34375rem'
        }
      }
    },
    flags: false,
    positionTemp: { x: 0, y: 0 }, // 记录手指点击的位置
    nx: '',
    ny: '',
    dx: '',
    dy: '',
    xPum: '',
    yPum: ''
  }),
  mixins: [Body],
  created() {
    const range = Math.min(document.body.clientWidth - 100, document.body.clientHeight - 100)
    this.width = range
    this.height = range
    document.title = '我的2024关键词'
    this.data = [
      '保卫发量',
      '披荆斩棘',
      '死磕到底',
      '不再犹豫',
      '升职加薪',
      '拒绝内卷',
      '活在当下',
      '水逆退散',
      '过关斩将',
      '做个勇士',
      '正面刚',
      '躺赢',
      '快意人生',
      '勇敢发声',
      '坠入爱河',
      '心有所爱',
      '拥有幸福',
      '内心柔软',
      '逢考必过',
      '人见人爱',
      '世界和平',
      '脱单',
      '瘦十斤',
      '干吃不胖',
      '电量满格',
      '人间清醒',
      '智商在线',
      '滚烫人生',
      '被爱环绕',
      '元气满满'
    ]
    this.contentEle = this.data.map(() => ({
      x: 0,
      y: 0,
      z: 0,
      style: {}
    }))
  },
  mounted() {
    this.innit()
    saTrack(
      'autoTrack',
      {
        web_type: '新年关键词',
        web_name: '新年关键词'
      },
      'quick'
    )
  },
  methods: {
    innit() {
      const RADIUSX = (this.width - 50) / 2
      const RADIUSY = (this.height - 50) / 2
      this.contentEle = []
      for (let i = 0; i < this.data.length; i += 1) {
        const k = -1 + (2 * (i + 1) - 1) / this.data.length
        const a = Math.acos(k)
        const b = a * Math.sqrt(this.data.length * Math.PI)
        const x = RADIUSX * Math.sin(a) * Math.cos(b)
        const y = RADIUSY * Math.sin(a) * Math.sin(b)
        const z = RADIUSX * Math.cos(a)
        const singleEle = {
          x,
          y,
          z,
          style: {}
        }
        this.contentEle.push(singleEle)
      }
      this.animate()
    },
    animate() {
      this.rotateX()
      this.rotateY()
      this.move()
      if (this.showFirstPage) {
        window.requestAnimationFrame(this.animate)
      }
    },
    async rotateX() {
      const angleX = ['-1', '1'].includes(this.direction)
        ? Math.PI / Infinity
        : Math.PI / ((Number(this.direction) / 2) * Number(this.speed))
      const cos = Math.cos(-angleX)
      const sin = Math.sin(-angleX)
      this.contentEle = this.contentEle.map(t => {
        const y1 = t.y * cos - t.z * sin
        const z1 = t.z * cos + t.y * sin
        return {
          ...t,
          y: y1,
          z: z1
        }
      })
    },
    async rotateY() {
      const angleY = ['-2', '2'].includes(this.direction)
        ? Math.PI / Infinity
        : Math.PI / (Number(this.direction) * Number(this.speed))
      const cos = Math.cos(angleY)
      const sin = Math.sin(angleY)
      this.contentEle = this.contentEle.map(t => {
        const x1 = t.x * cos - t.z * sin
        const z1 = t.z * cos + t.x * sin
        return {
          ...t,
          x: x1,
          z: z1
        }
      })
    },
    async move() {
      const CX = this.width / 2
      const CY = this.height / 2
      this.contentEle = this.contentEle.map(singleEle => {
        const { x, y, z } = singleEle
        const fallLength = this.width
        const RADIUS = (this.width - 50) / 2
        const scale = fallLength / (fallLength - z)
        const alpha = (z + RADIUS) / (2 * RADIUS)
        const left = `${x + CX - 15}px`
        const top = `${y + CY - 15}px`
        const transform = `translate(${left}, ${top}) scale(${scale / 1.6})`
        const style = {
          ...singleEle.style,
          opacity: alpha + 0.5,
          zIndex: parseInt(scale * 100, 10),
          transform
        }
        return {
          x,
          y,
          z,
          style
        }
      })
    },
    handleRotate(value) {
      this.direction = value
    },
    handleSpeed(value) {
      const speedObj = {
        fast: -50,
        slow: 50
      }
      this.speed += speedObj[value]
      if (this.speed === 0) {
        this.speed = 50
      }
    },
    // 微信登录后的操作
    getWXUserAfter_getData() {
      setTimeout(han => {
        this.$nextTick(this.checkDetail)
      }, 200)
    },
    hasUser() {
      const wxUser = storage.AppWeixinKey().getItem()
      if (!wxUser.openId) {
        toLoginView({})
        return false
      }
      return true
    },
    checkDetail() {
      if (location.href.indexOf('http:') >= 0) {
        this.showGif = true
        this.showFirstPage = false
        this.getPullNewDetailData()
      }
      if (!this.hasUser()) {
        return
      }
      this.showGif = true
      this.showFirstPage = false
      this.getPullNewDetailData()
    },
    showNote() {
      this.showMask = true
    },
    closeNote() {
      this.showMask = false
    },
    // 下面是second-page相关的方法
    onImageLoad() {
      this.createImage()
    },
    async createImage() {
      const capture = document.getElementById('capture')
      console.log('capture', capture.offsetWidth, capture.offsetHeight)
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      html2canvas(capture, {
        useCORS: true,
        width: capture.offsetWidth - 1,
        height: capture.offsetHeight - 1,
        scrollX: 0,
        scrollY: 0,
        scale: 3
      }).then(canvas => {
        // document.body.appendChild(canvas)
        const dataURL = canvas.toDataURL('image/png')
        // console.log('dataUrl', dataURL)
        this.canvasUrl = dataURL
        this.showBg = false
        console.log('图片生成完成')
        setTimeout(h => {
          this.showFirstPage = false
          this.showGif = false
        }, 1000)
      })
    },
    onBannerClick() {
      location.href = this.campUrl
    },
    onFloatClick() {
      location.href = 'https://s.ylyk.com/s/FVFfma'
      // this.detail.floatUrlHref
    },
    getPullNewDetailData() {
      const wxUser = storage.AppWeixinKey().getItem()
      console.log('getPullNewDetailData=appUser', appUser)
      console.log('getPullNewDetailData=wxUser', wxUser)
      if (location.href.indexOf('http:') >= 0) {
        wxUser.openId = 'o7h8PxI8oVFzHuk8JuTb2uFBHQyo'
      }
      if (wxUser.openId) {
        AsyncRequest({
          loading: false,
          request: () => pullnewService.pullnewDetail({ openId: wxUser.openId }),
          resolve: res => {
            // console.log('getPullNewDetailData=res', res)
            if (!this.headUrl) {
              const wxUser = storage.AppWeixinKey().getItem()
              this.headUrl = wxUser.avtarUrl
            }
            if (!this.nickName) {
              const wxUser = storage.AppWeixinKey().getItem()
              this.nickName = wxUser.nickName
            }
            if (this.nickName && this.nickName.length > 15) {
              this.nickName = this.nickName.slice(0, 15) + '...'
            }
            if (!this.headUrl) {
              this.hasHead = false
            }
            this.bgUrl = res.imageUrl
            // this.bgUrl = 'https://img-cdn1.ylyk.com/image/1702284338950_m1702284068311_s3094701.jpg'

            // this.headUrl = 'https://img-cdn1.ylyk.com/image/1698316469706_m1668578448782_s54655.jpg'
            // this.nickName = '你猜'
            this.coverUrl = res.coverUrl
            this.videoUrl = res.videoUrl
            this.bannerUrl = res.bannerUrl
            this.campUrl = res.bannerUrlHref
            this.detail = res
            saTrack('NewYearLotteryResult', {
              lottery_content: this.detail.id
            })
          },
          reject(reason) {
            console.log('getPullNewDetailData=err', reason)
          }
        })
      } else {
        setTimeout(h => {
          this.getPullNewDetailData()
        }, 500)
      }
    },
    palyVideo() {
      console.log('object')
      saTrack('NewYearVideoPlay', {
        lottery_content: this.detail.id
      })
    },
    // ----------------------------以下是悬浮球拖动相关的方法
    // 实现移动端拖拽
    down() {
      const moveDiv = document.getElementById('moveDiv')
      this.flags = true
      let touch
      // 该if判断是用touch还是mouse来移动
      if (event.touches) {
        touch = event.touches[0]
      } else {
        touch = event
      }
      this.positionTemp.x = touch.clientX // 手指点击后的位置
      this.positionTemp.y = touch.clientY

      this.dx = moveDiv.offsetLeft // 移动的div元素的位置
      this.dy = moveDiv.offsetTop

      // console.log("moveDiv.offsetLeft", moveDiv.offsetLeft)
      // console.log("touch.clientX", touch.clientX)
    },
    moveFloat() {
      const moveDiv = document.getElementById('moveDiv')
      if (this.flags) {
        let touch
        if (event.touches) {
          touch = event.touches[0]
        } else {
          touch = event
        }
        this.nx = touch.clientX - this.positionTemp.x // 手指移动的变化量
        this.ny = touch.clientY - this.positionTemp.y

        this.xPum = this.dx + this.nx // 移动后，div元素的位置
        this.yPum = this.dy + this.ny

        const windowWidth = document.documentElement.clientWidth
        const windowHeight = document.documentElement.clientHeight
        // console.log("window.clientWidth", windowWidth)
        // console.log(this.xPum)
        // console.log(" moveDiv.clientWidth",  moveDiv.clientWidth)

        if (this.xPum > 0 && this.xPum + moveDiv.clientWidth < windowWidth) {
          // movediv的左右边，未出界
          moveDiv.style.left = this.xPum + 'px'
        } else if (this.xPum <= 0) {
          // 左边出界，则左边缘贴边
          moveDiv.style.left = 0 + 'px'
        } else if (this.xPum + moveDiv.clientWidth >= windowWidth) {
          // 右边缘出界
          moveDiv.style.left = windowWidth - moveDiv.clientWidth + 'px'
          // console.log("dx", windowWidth - moveDiv.clientWidth)
        }
        // 上下未出界
        if (this.yPum > 0 && this.yPum + moveDiv.clientHeight < windowHeight) {
          moveDiv.style.top = this.yPum + 'px'
        } else if (this.yPum <= 0) {
          // 上边缘出界
          moveDiv.style.top = 0 + 'px'
        } else if (this.yPum + moveDiv.clientHeight >= windowHeight) {
          // 下边缘
          // console.log("windowHeight:", windowHeight)
          // console.log("moveDiv.clientHeight:", moveDiv.clientHeight)
          // console.log(this.yPum + moveDiv.clientHeight)
          moveDiv.style.top = windowHeight - moveDiv.clientHeight + 'px'
        }

        // 阻止页面的滑动默认事件，为了只让悬浮球滑动，其他部分不滑动；如果碰到滑动问题，1.2 请注意是否获取到 touchmove, 系统默认passive: true，无法使用preventDefault
        // document.addEventListener("touchmove", function(){
        //    event.preventDefault();
        // }, { passive: false });
        // document.addEventListener("mousemove", function(){
        //     event.preventDefault();
        // }, { passive: false });
        document.addEventListener('touchmove', this.preventDefault, { passive: false })
        document.addEventListener('mousemove', this.preventDefault, { passive: false })
      }
    },
    // 鼠标释放时候的函数，鼠标释放，移除之前添加的侦听事件，将passive设置为true，不然背景会滑动不了
    end() {
      this.flags = false
      // 注意事项，在添加和删除监听事件时，其function必须是同名的函数，不能为匿名函数。
      document.removeEventListener('touchmove', this.preventDefault, false)
      document.removeEventListener('mousemove', this.preventDefault, false)
      // 下面两句是保证在移除监听事件后，除了悬浮球的部分还能够滑动，如果不添加，则无法滑动
      document.addEventListener('touchmove', function (e) {
        window.event.returnValue = true
      })
      document.addEventListener('mousemove', function (e) {
        window.event.returnValue = true
      })
    },
    preventDefault(e) {
      e.preventDefault()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
.first-page {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  // justify-content: center;
  // width: 100%;
  //height: 100%;
  z-index: 999;
  overflow-x: hidden;
  overflow-y: scroll;
  background: url('https://img-cdn1.ylyk.com/1672197580_23456894.gif') no-repeat;
  background-size: 100% 100%;
  background-color: #00002e;
  .img_detail {
    // position: absolute;
    top: 0;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  .wordCloud__tagBall {
    margin: 100px auto 50px;
    position: relative;
    background-image: url('https://img-cdn1.ylyk.com/image/1638526222216_m1638526143061_s44102.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .wordCloud__tag {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    color: green;
    text-decoration: none;
    font-size: 0.24rem;
    & > hover {
      color: red;
    }
  }
  .wordCloud__home {
    display: flex;
    justify-content: center;
  }
  .btn_detail {
    color: white;
    // background-color: #00B25A;
    background: url(../../images/btn_bg.png) no-repeat;
    background-size: contain;
    padding: 0.2rem 1rem;
    border-radius: 0.4rem;
    // position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
  }
  .note {
    text-decoration: underline;
    color: #fff;
    margin-top: 0.48rem;
    font-size: 0.28rem;
    // position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
  }
}
.mask {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 1000;
  padding: 1rem 0.5rem;
  .decorate {
    position: absolute;
    left: 0;
    top: 0;
    width: 1.62rem;
    height: 2rem;
  }
  .note-content {
    width: 100%;
    height: 100%;

    background: #fff0c6;
    border-radius: 0.08rem;
    padding: 0.4rem;
    position: relative;
    overflow: auto;
    .pre {
      // height: 100%;
      // white-space: pre-wrap;
      color: #9e2600;
      font-size: 0.28rem;
      .title {
        font-weight: bold;
      }
      b {
        display: inline-block;
        margin-bottom: 0.08rem;
        margin-top: 0.4rem;
      }

      .commit {
        line-height: 0.36rem;
      }
    }
  }
  .close {
    margin-top: 0.6rem;
    width: 0.64rem;
    height: 0.64rem;
  }
}
.mask-gif {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  position: fixed;
  background-color: #00002e;
  top: 0;
  left: 0;
  z-index: 1001;
  .img-gif {
    width: 3rem;
    height: 3rem;
    margin-bottom: 0.6rem;
  }
}
.second-page {
  width: 100%;
  background-color: #00002e;
  padding-bottom: 1.24rem;
  .top {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    background-color: #fcdccf;
    height: 0.72rem;
    font-size: 0.28rem;
    color: black;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    img {
      width: 0.39rem;
      height: 0.48rem;
      margin-left: 0.24rem;
    }
  }
  .main {
    width: 100%;
    height: auto;
    margin-top: 0.72rem;
    .pic-main {
      display: flex;
      flex-flow: row;
      .decorate-l {
        width: 0.2rem;
        height: 1.1rem;
        margin-top: 0.48rem;
        margin-left: 0.16rem;
      }
      .decorate-r {
        width: 0.16rem;
        height: 0.92rem;
        margin-right: 0.2rem;
        position: absolute;
        bottom: 0.1rem;
        right: 0;
      }
      .pic-wrapper {
        position: relative;
        margin-top: 0.48rem;
        margin-left: 0.48rem;
        margin-right: 0.48rem;
        background-color: rgba(105, 228, 244, 0.18);
        width: 100%;
        .cover {
          width: 100%;
          display: block;
          float: right;
          //margin-right: 8px;
          //margin-bottom: 8px;
          //margin-top: -8px;
        }
        .div-user {
          position: absolute;
          top: 1.4rem;
          display: flex;
          flex-flow: column;
          width: 100%;
          align-items: center;
          margin-right: 8px;
          .avatar {
            border-radius: 50%;
            width: 0.92rem;
            height: 0.92rem;
          }
          .nickName {
            color: white;
            font-size: 0.24rem;
            height: 0.4rem;
            // line-height: 0.4rem;
            margin-top: 0.24rem;
          }
        }
        .div-qrcode {
          position: absolute;
          bottom: 0.5rem;
          right: 0.5rem;
          display: flex;
          align-items: center;
          color: #000;
          .tv_ {
            font-size: 0.22rem;
            text-align: right;
            line-height: 0.25rem;
          }
          .img-qrcode {
            width: 1rem;
            height: 1rem;
            margin-left: 0.2rem;
          }
        }
      }
    }
    .video {
      // margin-top: 0.5rem;
      padding-left: 0.48rem;
      padding-right: 0.48rem;
      width: 100%;
    }
    .banner-title {
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-top: .74rem;
      color: #69e4f4;
      font-size: 0.26rem;
      margin-left: 0.48rem;
      margin-right: 0.48rem;
      img {
        width: 1.6rem;
        height: 0.48rem;
      }
    }
    .specialTitle1 {
      margin-top: 0.26rem;
      margin-bottom: 0.26rem;
      img {
        width: 1rem;
        height: 0.48rem;
      }
    }
    .specialTitle2 {
      margin-top: 0.26rem;
      margin-bottom: 0.26rem;
    }
    .banner {
      width: 100%;
      height: 2.26rem;
      // margin-top: 0.44rem;
      display: block;
      padding-left: 0.48rem;
      padding-right: 0.48rem;
    }
    .decorate-circle-1 {
      width: 3.12rem;
      height: 4.12rem;
      position: absolute;
      left: 0;
      top: 5rem;
    }
  }
}
.floating {
  position: fixed;
  bottom: 1.08rem;
  right: 0.4rem;
  width: 1.5rem;
  height: 1.5rem;
  z-index: 9999;
}
</style>
